import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map, Observable } from 'rxjs';
import {
  AcceptOAuth2ConsentRequest,
  OAuth2ConsentRequest, OAuth2ConsentSession,
  OAuth2LogoutRequest,
  OAuth2RedirectTo, RejectOAuth2Request
} from '../../sdk/hydra';

@Injectable({
  providedIn: 'root'
})
export class Oauth2Service {
  private basePath = environment.bangumiProviderBasePath;
  constructor(private httpClient: HttpClient) {
  }

  getConsent(consentChallenge: string): Observable<OAuth2ConsentRequest> {
    return this.httpClient.get<OAuth2ConsentRequest>(`${this.basePath}/authorize/consent`, {
      withCredentials: true,
      params: {
        'consent_challenge': consentChallenge
      }
    });
  }

  acceptConsent(content: AcceptOAuth2ConsentRequest, consentChallenge: string): Observable<string> {
    return this.httpClient.put<OAuth2RedirectTo>(`${this.basePath}/authorize/consent/accept`, content, {
      withCredentials: true,
      params: {
        'consent_challenge': consentChallenge
      }
    }).pipe(map(res => res.redirect_to));
  }

  rejectConsent(consentChallenge: string, error: RejectOAuth2Request): Observable<string> {
    return this.httpClient.put<OAuth2RedirectTo>(`${this.basePath}/authorize/consent/reject`, error, {
      withCredentials: true,
      params: {
        'consent_challenge': consentChallenge
      }
    }).pipe(map(res => res.redirect_to));
  }

  getLogoutConsent(logoutChallenge: string): Observable<OAuth2LogoutRequest> {
    return this.httpClient.get<OAuth2LogoutRequest>(`${this.basePath}/authorize/logout`, {
      withCredentials: true,
      params: {
        'logout_challenge': logoutChallenge
      }
    });
  }

  acceptLogoutConsent(logoutChallenge: string): Observable<string> {
    return this.httpClient.put<OAuth2RedirectTo>(`${this.basePath}/authorize/logout/accept`, null, {
      withCredentials: true,
      params: {
        'logout_challenge': logoutChallenge
      }
    }).pipe(map(res => res.redirect_to));
  }

  rejectLogoutConsent(logoutChallenge: string): Observable<any> {
    return this.httpClient.put<any>(`${this.basePath}/authorize/logout/reject`, null, {
      withCredentials: true,
      params: {
        'logout_challenge': logoutChallenge
      }
    });
  }

  listConsentSessions(pageToken?: string): Observable<{ data: OAuth2ConsentSession[], first?: string, next?: string }> {
    const params: any = {};
    if (pageToken) {
      params.pageToken = pageToken;
    }
    return this.httpClient.get<{
      status: number,
      data: { data: OAuth2ConsentSession[], first?: string, next?: string }
    }>(`${this.basePath}/api/oauth2/consent`, {
      withCredentials: true,
      params
    })
      .pipe(map(result => result.data));
  }

  RevokeSession(sid: string): Observable<any> {
    return this.httpClient.delete(`${this.basePath}/api/oauth2/sessions/login`, {
      withCredentials: true,
      params: {
        sid
      }
    });
  }

  RevokeClientConsent(clientId: string): Observable<any> {
    return this.httpClient.delete(`${this.basePath}/api/oauth2/sessions/consent`, {
      withCredentials: true,
      params: {
        client: clientId
      }
    });
  }
}
